import React from "react";
import PropTypes from "prop-types";
import Form from "../Form/form";
import {controlPropTypes} from "../formhelpers";

class Columnset extends React.Component {
    render() {
        const {
            descriptor
        } = this.props;
        const selector = `control-container-${descriptor.key}`;
        return (
            <div
                id={descriptor.id}
                className={`${selector} control-layout-columnset`}
            >
                <Form {...this.props} />
            </div>
        );
    }
}

Columnset.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

Columnset.propTypes = {
    ...controlPropTypes(null, false, true),
    propsResolver: PropTypes.func.isRequired,
    onCommitChange: PropTypes.func, // not required
};

export default Columnset;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/Layout/columnset.js